import React from "react";

import { TimelineEvent } from "./Types";
import { Timeline, TimelineContainer } from "./GameTimeline.styles";
import { GameTimelineFactory } from "./Factory/GameTimelineFactory";

export function GameTimeline({
    timeline,
    itemsToShow,
}: {
    timeline: TimelineEvent[];
    itemsToShow?: number;
}) {
    return (
        <TimelineContainer>
            <Timeline>
                {timeline
                    ?.slice(0, itemsToShow)
                    .map((item) => (
                        <GameTimelineFactory
                            key={item.id}
                            timelineEvent={item}
                        />
                    ))}
            </Timeline>
        </TimelineContainer>
    );
}
